import httpClient from './httpClient'

export default {
  SmtpServer: {
    GetSmtpServer(payload) {
      return httpClient.post('/SmtpServer/GetSmtpServer', payload)
    },
    TestConnection(payload) {
      return httpClient.post('/SmtpServer/TestConnection', payload)
    },
    UpdateSmtpServer(payload) {
      return httpClient.post('/SmtpServer/UpdateSmtpServer', payload)
    },
  },
}
